import { j as o } from "./jsx-runtime-DmTjM30f.mjs";
import { forwardRef as y, useState as h } from "react";
import { c as p } from "./tw-cn-mXgPecoF.mjs";
import { ERROR_IMAGE_URL as b } from "./utils.es.js";
import { e as n } from "./extract-responsive-property-BiJ5BiwI.mjs";
import { c as v } from "./index-BpNK5r1N.mjs";
const x = v(["relative overflow-hidden"], {
  variants: {
    ratio: {
      "3_4": "aspect-[3/4]",
      "2_3": "aspect-[2/3]",
      "1_1": "aspect-[1/1]",
      "2_1": "aspect-[2/1]",
      "3_2": "aspect-[3/2]"
    },
    shape: {
      roundedRectangle_8: "rounded-8",
      roundedRectangle_12: "rounded-12",
      roundedRectangle_16: "rounded-16",
      capsule: "rounded-capsule",
      rectangle: "",
      asymmetric_12_12_0_0: "rounded-t-12"
    },
    pcRatio: {
      "3_4": "pc:aspect-[3/4]",
      "2_3": "pc:aspect-[2/3]",
      "1_1": "pc:aspect-[1/1]",
      "2_1": "pc:aspect-[2/1]",
      "3_2": "pc:aspect-[3/2]"
    },
    pcShape: {
      roundedRectangle_8: "pc:rounded-8",
      roundedRectangle_12: "pc:rounded-12",
      roundedRectangle_16: "pc:rounded-16",
      capsule: "pc:rounded-capsule",
      rectangle: "",
      asymmetric_12_12_0_0: "pc:rounded-t-12"
    }
  }
}), j = ({ alt: e, className: r, src: t, onError: a }) => /* @__PURE__ */ o.jsx("img", { alt: e, className: r, onError: a, src: t }), E = y(
  ({ shape: e, ratio: r, image: t, alt: a, className: d, imgClassName: l, imageComponent: m, children: u, width: c, ...i }, _) => {
    const [s, R] = h(!1), f = m ?? j, g = x({
      ...n({
        property: e,
        mobileKey: "shape",
        pcKey: "pcShape"
      }),
      ...n({
        property: r,
        mobileKey: "ratio",
        pcKey: "pcRatio"
      })
    });
    return /* @__PURE__ */ o.jsxs(
      "div",
      {
        className: p(g, d),
        ref: _,
        style: { width: c ? `${c / 10}rem` : void 0 },
        ...i,
        children: [
          /* @__PURE__ */ o.jsx(
            f,
            {
              alt: a ?? "Thumbnail",
              className: p("mx-auto size-full bg-fill-neutral-weak1 object-center", l, {
                "object-cover": !s
              }),
              onError: () => {
                R(!0);
              },
              src: s ? b : t
            }
          ),
          u
        ]
      }
    );
  }
);
E.displayName = "NDS.Thumbnail";
export {
  E as T
};
